'use client';

import { Utils } from '@/lib/utils';
import { getCookie } from 'cookies-next';
import { useRouter } from 'next/navigation';
import { useState } from 'react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';

export default function LanguageSwitcher() {
      const router = useRouter();
      const [locale, setLocale] = useState(getCookie('NEXT_LOCALE') ?? 'en');

      const availableLocales: { code: string, title: string }[] = [
            { code: 'pt', title: 'PT' },
            { code: 'en', title: 'EN' },
      ];


      const changeLanguage = (newLocale: string) => {
            setLocale(newLocale);
            // Armazena o novo locale em um cookie
            Utils.cookie.set('NEXT_LOCALE', newLocale);
            // Atualiza a página para aplicar o novo idioma
            router.refresh();
      };

      return (
            <Select onValueChange={(lang) => changeLanguage(lang)} defaultValue={locale as string}>
                  <SelectTrigger className='border-none outline-none shadow-none'>
                        <SelectValue placeholder="Selecione o idioma" />
                  </SelectTrigger>
                  <SelectContent>
                        {availableLocales.map((locale) => {
                              return <SelectItem key={locale.code} value={locale.code}>
                                    {locale.title}
                              </SelectItem>
                        })}
                  </SelectContent>
            </Select>
      );
} 